import React from "react";
import EmployeesTable from "../requests/manager/employees/EmployeesTable";
import ArchivedEmployeesTable from "../requests/manager/employees/ArchivedEmployeesTable";
import CertificationsTable from "./CertificationsTable";
import ToastEmployeeLinkModal from "../requests/manager/employees/ToastEmployeeLinkModal";
import TabsThree from "../requests/shared/helpers/TabsThree";
import {
  API_get_list_users,
  API_get_store_team_member,
  API_get_roles,
  API_store_team_member_set_hide,
  API_store_team_member_set_order,
  API_post_store_team_member,
  API_archive_store_team_member,
  API_get_archived_store_team_members,
  API_update_team_member_info,
  API_post_certificate,
  API_delete_certificate,
  API_get_logbook_employee_entries,
  API_post_logbook_employee_entry,
  API_delete_logbook_employee_entry,
  API_get_file_upload,
  API_get_stores_company_manager,
  API_clone_or_reactivate_store_team_member,
  API_post_store_team_member_only_permission_type_and_store_id,
  API_create_availability_request,
  API_manager_rescind_availability_request,
  API_list_pos_store_team_members,
  API_create_store_team_member_from_pos_store_team_member,
  API_link_pos_store_team_member,
  API_archive_pos_store_team_member,
  API_update_emergency_contact,
  API_get_list_time_off_requests_for_stm,
  API_request_time_off,
  API_rescind_time_off_request,
} from "../../../constants";
import { getRightworkAPI } from "../requests/utilities/requests";
import { postRightworkAPI } from "../requests/utilities/requests";
import { formatDate } from "../requests/utilities/helpers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadSpinner from "../../../utilities/LoadSpinner";
import Account from "../home/top_bar_components/Account";
import StoreName from "../home/top_bar_components/StoreName";
import TopBarDisplayTitle from "../home/top_bar_components/TopBarDisplayTitle";
import { getDefaultAxiosConfig } from "../requests/utilities/requests";
import axios from "axios";
import { Lightbox } from "react-modal-image";

function EmployeesInformationDisplay(props) {
  const [data, setData] = React.useState([]);
  const [selectedTeamMemberData, setSelectedTeamMemberData] = React.useState();
  const [
    selectedTeamMemberAvailabilityData,
    setSelectedTeamMemberAvailabilityData,
  ] = React.useState();
  const [relatedTeamMembersData, setRelatedTeamMembersData] = React.useState();
  const [selectedTeamMemberId, setSelectedTeamMemberId] = React.useState(null);
  const [selectedTeamMemberTimeOffData, setSelectedTeamMemberTimeOffData] =
    React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  const [showLighbox, setShowLightbox] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);

  const [activeEmployeeTab, setActiveEmployeeTab] = React.useState("Current");

  // console.log("SELECTEDTEAMMEMBERID", selectedTeamMemberId);

  const default_api_calls = {
    users: API_get_list_users,
    archivedUsers: API_get_archived_store_team_members,
    roleNames: API_get_roles,
    storeList: API_get_stores_company_manager,
    posStoreTeamMembers: API_list_pos_store_team_members
  };

  // Get the current date
  let currentDate = new Date();
  // Get the start date of the previous month
  let lowerBoundDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    1
  );
  // Get the end date of the next month
  let upperBoundDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 2,
    0
  );

  let lowerBoundDateStr = formatDate(lowerBoundDate);
  let upperBoundDateStr = formatDate(upperBoundDate);

  let api_params = {
    store_id: props.homeStore,
    company_id: props.homeCompany,
    lower_bound_date: lowerBoundDateStr,
    upper_bound_date: upperBoundDateStr,
    specific_date: formatDate(currentDate),
    date_start: formatDate(currentDate),
    date_end: formatDate(currentDate),
  };

  const fetch_data = async (api_calls, api_params, showLoading) => {
    setIsLoading(showLoading);
    let api_set_data_name = Object.keys(api_calls);
    let api_list = Object.values(api_calls);
    try {
      // console.log("CALLING APIS");
      const res = await Promise.all(
        api_list.map((api) => getRightworkAPI(api, api_params))
      );
      var tempData = { ...data };
      res.map((res, i) => (tempData[api_set_data_name[i]] = res.data));
      setIsLoading(false);
      setData(tempData);
    } catch (error) {
      // console.log(error);
      //throw Error(error);
    }
  };

  const [selectedTeamMemberLoadFailed, setSelectedTeamMemberLoadFailed] =
    React.useState(false);

  // Token for the most recent member request; older responses are ignored so
  // a slow fetch can't overwrite a newer selection.
  const latestMemberFetchRef = React.useRef(0);
  // The id most recently requested, success or failure, so "Try again" on a
  // failed load knows which member to refetch.
  const lastRequestedMemberIdRef = React.useRef(null);

  // `openingProfile`: the request is opening a profile (row click or schedule
  // deep link) rather than refreshing one already on screen. Opens start from
  // a clean slate so a failed load shows the error state, never cached data.
  const fetchStoreTeamMember = async (showLoading, stm_id, openingProfile = showLoading) => {
    const fetchToken = ++latestMemberFetchRef.current;
    lastRequestedMemberIdRef.current = stm_id;
    setIsLoading(showLoading);
    setSelectedTeamMemberLoadFailed(false);
    setSelectedTeamMemberData((current) =>
      openingProfile || (current && current.id !== stm_id) ? undefined : current
    );
    let api_params = {
      store_id: props.homeStore,
      stm_id: stm_id,
    };
    let api = API_get_store_team_member;
    try {
      const res = await getRightworkAPI(api, api_params);
      if (fetchToken !== latestMemberFetchRef.current) return;
      if (res && res.status === 200) {
        console.log("STORE TEAM MEMBER", res.data.redux?.payload);
        setSelectedTeamMemberData(res.data.redux?.payload?.employee);
        setSelectedTeamMemberAvailabilityData(
          res.data.redux?.payload?.employee_availability
        );
        setRelatedTeamMembersData(
          res.data.redux?.payload?.related_store_team_members
        );
        setIsLoading(false);
      } else {
        setSelectedTeamMemberLoadFailed(true);
        setIsLoading(false);
      }
    } catch (error) {
      if (fetchToken !== latestMemberFetchRef.current) return;
      setSelectedTeamMemberLoadFailed(true);
      setIsLoading(false);
      throw Error(error);
    }
  };

  const latestTimeOffFetchTokenRef = React.useRef(0);
  // Always reflect the latest selection. Used to detect stale closures (e.g. a
  // request_time_off_for_employee/rescind_time_off_request .then callback firing
  // after the manager has switched employees) so they don't kick off a fetch for
  // the previous selection and interfere with the current employee's in-flight
  // request.
  const latestTimeOffStmIdRef = React.useRef(null);
  const latestTimeOffStoreIdRef = React.useRef(props.homeStore);

  const fetchSelectedTeamMemberTimeOff = async (stm_id) => {
    if (!stm_id) {
      setSelectedTeamMemberTimeOffData([]);
      return;
    }
    // Time off is a scheduling/approvals surface. When the store has scheduling
    // off, the Team Members screen stays reachable but must not fetch or expose
    // hidden time-off data (the profile's Time Off / Availability tabs are also
    // hidden in EmployeeProfile when schedulingEnabled is false).
    if (props.schedulingEnabled === false) {
      setSelectedTeamMemberTimeOffData([]);
      return;
    }
    const requestStmId = stm_id;
    const requestStoreId = props.homeStore;
    // If the closure is stale (e.g. called from an old post-action .then after
    // an employee/store switch), skip without advancing the token so we don't
    // drop the current selection's in-flight fetch.
    if (latestTimeOffStmIdRef.current !== requestStmId) return;
    if (latestTimeOffStoreIdRef.current !== requestStoreId) return;
    const token = ++latestTimeOffFetchTokenRef.current;
    try {
      const res = await getRightworkAPI(
        API_get_list_time_off_requests_for_stm,
        {
          store_id: requestStoreId,
          store_team_member_id: requestStmId,
        }
      );
      // Drop the response if a newer fetch has started or the manager has
      // since switched selection — protects against stale data overwriting state.
      if (token !== latestTimeOffFetchTokenRef.current) return;
      if (latestTimeOffStmIdRef.current !== requestStmId) return;
      if (latestTimeOffStoreIdRef.current !== requestStoreId) return;
      if (res && res.status === 200) {
        setSelectedTeamMemberTimeOffData(
          res.data?.redux?.payload?.timeOffRequests || []
        );
      }
    } catch (error) {
      console.error("Error loading employee time off:", error);
    }
  };

  React.useEffect(() => {
    // Sync refs synchronously with the new selection, bump the token so any
    // in-flight fetch from the previous selection is invalidated, and clear
    // immediately so the previous employee/store's rows aren't visible while loading.
    latestTimeOffStmIdRef.current = selectedTeamMemberId;
    latestTimeOffStoreIdRef.current = props.homeStore;
    latestTimeOffFetchTokenRef.current += 1;
    setSelectedTeamMemberTimeOffData([]);
    fetchSelectedTeamMemberTimeOff(selectedTeamMemberId);
  }, [selectedTeamMemberId, props.homeStore]);

  const request_time_off_for_employee = async (data) => {
    const requestData = { ...data, store_id: props.homeStore };
    try {
      toast.loading("Submitting Time Off Request...", { autoClose: false });
      const res = await postRightworkAPI(API_request_time_off, requestData);
      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Time Off Request Submitted!", { autoClose: 3000 });
        fetchSelectedTeamMemberTimeOff(selectedTeamMemberId);
      }
    } catch (error) {
      toast.dismiss();
      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }
    }
  };

  const rescind_time_off_request = async (time_off_request_uuid) => {
    const requestData = {
      store_id: props.homeStore,
      time_off_request_uuid: time_off_request_uuid,
    };
    try {
      toast.loading("Cancelling Time Off Request...", { autoClose: false });
      const res = await postRightworkAPI(
        API_rescind_time_off_request,
        requestData
      );
      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Time Off Request Cancelled", { autoClose: 3000 });
        fetchSelectedTeamMemberTimeOff(selectedTeamMemberId);
      }
    } catch (error) {
      toast.dismiss();
      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }
    }
  };

  // ----------- POST APIs ----------- //
  const hide_store_team_member = async (store_team_member_id, hidden) => {
    // Prepare data to send
    const requestData = {
      store_team_member_id: store_team_member_id,
      hidden: hidden,
    };

    try {
      toast.loading("Updating Employee...", { autoClose: false });
      const res = await postRightworkAPI(
        API_store_team_member_set_hide,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        const futureShiftCount =
          res.data?.redux?.payload?.future_shift_count;
        if (futureShiftCount && hidden === "true") {
          const confirmDelete = window.confirm(
            `This team member has ${futureShiftCount} upcoming shift${futureShiftCount === 1 ? "" : "s"}. Delete them?`
          );
          if (confirmDelete) {
            toast.loading("Deleting Shifts...", { autoClose: false });
            await postRightworkAPI(API_store_team_member_set_hide, {
              ...requestData,
              delete_shifts: "true",
            });
            toast.dismiss();
          }
        }

        toast.success("Employee Updated Successfully!", { autoClose: 3000 });
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  const store_team_member_set_order = async (store_team_member_settings) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      store_team_member_settings: JSON.stringify(store_team_member_settings),
    };

    try {
      toast.loading("Setting Employees Order...", { autoClose: false });
      const res = await postRightworkAPI(
        API_store_team_member_set_order,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Order Set Successfully!", { autoClose: 3000 });
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
        // Further handle success case as per your requirement
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error); // Handle error as needed
    }
  };

  const post_store_team_member = async (
    first_name,
    last_name,
    email,
    phone_number,
    permission_type,
    stm_id,
    clock_pin,
    date_of_birth,
    date_of_hire,
    send_welcome_email = true,
    available_role_info = null,
    can_request_pto = null,
    can_request_sicktime = null,
    emergency_contact_name = null,
    emergency_contact_phone = null,
    emergency_contact_relationship = null,
    welcome_channel = "email"
  ) => {
    // Prepare data to send
    const requestData = {
      stm_id: stm_id,
      store_id: props.homeStore,
      first_name: first_name,
      last_name: last_name,
      email: email,
      phone_number: phone_number,
      permission_type: permission_type,
      clock_pin: clock_pin,
      date_of_birth: date_of_birth,
      date_of_hire: date_of_hire,
      send_welcome_email: send_welcome_email,
      welcome_channel: welcome_channel,
    };

    // Only include available_role_info if it's explicitly provided
    if (available_role_info !== null) {
      requestData.available_role_info = JSON.stringify(available_role_info);
    }

    // Only include time off flags if they're explicitly provided
    if (can_request_pto !== null) {
      requestData.can_request_pto = can_request_pto;
    }
    if (can_request_sicktime !== null) {
      requestData.can_request_sicktime = can_request_sicktime;
    }

    // Only include emergency contact fields if they're explicitly provided
    if (emergency_contact_name !== null) {
      requestData.emergency_contact_name = emergency_contact_name;
    }
    if (emergency_contact_phone !== null) {
      requestData.emergency_contact_phone = emergency_contact_phone;
    }
    if (emergency_contact_relationship !== null) {
      requestData.emergency_contact_relationship = emergency_contact_relationship;
    }

    // console.log("Company ID", requestData);

    try {
      const isCreatingEmployee = !stm_id;
      toast.loading(
        `${isCreatingEmployee ? "Adding" : "Updating"} Employee...`,
        { autoClose: false }
      );

      const res = await postRightworkAPI(
        API_post_store_team_member,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success(
          `Employee ${isCreatingEmployee ? "Added" : "Updated"}!`,
          { autoClose: 3000 }
        );
        if (selectedTeamMemberId) {
          fetchStoreTeamMember(false, selectedTeamMemberId);
        }
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed

      // Re-throw the error so the caller knows the save failed
      throw error;
    }
  };

  // [POST] api/pos_info/create_store_team_member_from_pos_store_team_member
  // * store_id (auth)
  // * pos_store_team_member_uuid
  // * create_across_company (optional, boolean) - if true, creates STMs for all POSStoreTeamMembers across all company stores
  const import_store_team_members_from_pos = async (
    pos_store_team_member_uuid,
  ) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      pos_store_team_member_uuid: pos_store_team_member_uuid,
    };

    // console.log("Company ID", requestData);

    try {
      toast.loading("Importing Employee...", { autoClose: false });

      const res = await postRightworkAPI(
        API_create_store_team_member_from_pos_store_team_member,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Employee Imported!", { autoClose: 3000 });
        fetch_data(
          {
            users: API_get_list_users,
            posStoreTeamMembers: API_list_pos_store_team_members
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const archive_store_team_member = async (store_id, stm_id, reason = "", rehire_eligible = true) => {
    // Prepare data to send
    const requestData = {
      store_id: store_id,
      stm_id: stm_id,
      company_id: props.homeCompany,
      archive_reason: reason,
      rehire_eligible: rehire_eligible,
    };

    try {
      toast.loading("Deleting Access...", { autoClose: false });

      const res = await postRightworkAPI(
        API_archive_store_team_member,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Access deleted!", { autoClose: 3000 });

        fetchStoreTeamMember(false, selectedTeamMemberId);
        fetch_data(
          {
            users: API_get_list_users,
            archivedUsers: API_get_archived_store_team_members,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };


  // [POST] api/pos_info/link_pos_store_team_member
  // - pos_store_team_member_uuid
  // - store_team_member_id
  // - store_id
  const link_pos_store_team_member = async (pos_store_team_member_uuid, store_team_member_id) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      pos_store_team_member_uuid: pos_store_team_member_uuid,
      store_team_member_id: store_team_member_id
    };

    try {
      toast.loading("Linking Employees...", { autoClose: false });

      const res = await postRightworkAPI(
        API_link_pos_store_team_member,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Employees Linked!", { autoClose: 3000 });

        fetch_data(
          {
            users: API_get_list_users,
            posStoreTeamMembers: API_list_pos_store_team_members
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  // [POST] api/pos_info/archive_pos_store_team_member
  const archive_pos_store_team_member = async (pos_store_team_member_uuid) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      pos_store_team_member_uuid: pos_store_team_member_uuid,
      company_id: props.homeCompany,
    };

    try {
      toast.loading("Excluding Employee...", { autoClose: false });

      const res = await postRightworkAPI(
        API_archive_pos_store_team_member,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Access excluded!", { autoClose: 3000 });

        fetch_data(
          {
            posStoreTeamMembers: API_list_pos_store_team_members
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };


  const updatePersonInfo = async (data) => {
    try {
      toast.loading("Updating Employee Attributes...", { autoClose: false });

      const axiosConfig = await getDefaultAxiosConfig();
      const res = await axios.put(
        API_update_team_member_info + props.homeStore,
        data,
        axiosConfig
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Employee Attributes Updated!", { autoClose: 3000 });

        try {
          await fetchStoreTeamMember(false, selectedTeamMemberId);
          await fetch_data(
            {
              users: API_get_list_users,
            },
            api_params
          );
        } catch (error) {
          // The PUT completed; a failed GET must not invite a duplicate save.
          toast.warn("Employee attributes saved, but could not refresh. Reload to see the latest values.", { autoClose: 5000 });
          console.error("Error refreshing saved employee attributes:", error);
        }
        return true;
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
    return false;
  };

  const post_certificate = async (
    store_team_member_id,
    certificate_uuid,
    type,
    expiration_date,
    image,
    clear_file
  ) => {
    const formData = new FormData();

    formData.append("store_id", props.homeStore);
    formData.append("store_team_member_id", store_team_member_id);
    formData.append("certificate_uuid", certificate_uuid);
    formData.append("type", type);
    formData.append("expiration_date", expiration_date);
    formData.append("image", image);
    if (clear_file) {
      formData.append("clear_file", "true");
    }

    try {
      toast.loading("Updating Certificate...", { autoClose: false });

      const axiosConfig = await getDefaultAxiosConfig();

      const res = await axios.post(API_post_certificate, formData, {
        headers: {
          ...axiosConfig.headers, // Merge default axios headers with multipart/form-data headers
          "Content-Type": "multipart/form-data", // Set content type for file upload
        },
      });

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Certificate Updated!", { autoClose: 3000 });

        fetchStoreTeamMember(false, selectedTeamMemberId);
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const delete_certificate = async (store_team_member_id, certificate_uuid) => {
    // Prepare data to send
    const requestData = {
      store_id: props.homeStore,
      store_team_member_id: store_team_member_id,
      certificate_uuid: certificate_uuid,
    };

    try {
      toast.loading("Deleting Certificate...", { autoClose: false });

      const res = await postRightworkAPI(API_delete_certificate, requestData);

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Certificate Deleted!", { autoClose: 3000 });

        fetchStoreTeamMember(false, selectedTeamMemberId);
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  // [GET] api/file_upload_info/get_file_upload
  // * file_upload_uuid
  const get_file_upload = async (file_upload_uuid) => {
    let api_params = {
      file_upload_uuid: file_upload_uuid,
    };
    try {
      const res = await getRightworkAPI(API_get_file_upload, api_params);
      if (res.status === 200) {
        setSelectedImage(res.data.redux?.payload?.presigned_url);
        setShowLightbox(true);
      }
    } catch (error) {
      throw Error(error);
    }
  };

  // [POST] api/logbook_info/post_logbook_employee_entry
  // * store_team_member_id (auth)
  // * value_text
  // * file_upload_uuids (optional)
  //     JSON.stringify(["08h0-2fuinf2-2fjin-2ff2f"])
  const post_logbook_employee_entry = async (
    store_team_member_id,
    value_text,
    file_upload_uuids
  ) => {
    const requestData = {
      store_team_member_id: store_team_member_id,
      value_text: value_text,
      file_upload_uuids: JSON.stringify(file_upload_uuids),
    };

    try {
      toast.loading("Saving Note...", { autoClose: false });

      const res = await postRightworkAPI(
        API_post_logbook_employee_entry,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Note Saved Successfully", { autoClose: 3000 });
        fetchStoreTeamMember(false, selectedTeamMemberId);
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();
      // handlePostError(error);
    }
  };

  // [POST] api/logbook_info/delete_logbook_employee_entry
  // * store_team_member_id (auth)
  // * logbook_employee_entry_uuid
  const delete_logbook_employee_entry = async (
    store_team_member_id,
    logbook_employee_entry_uuid
  ) => {
    const requestData = {
      store_team_member_id: store_team_member_id,
      logbook_employee_entry_uuid: logbook_employee_entry_uuid,
    };

    try {
      toast.loading("Deleting Note...", { autoClose: false });

      const res = await postRightworkAPI(
        API_delete_logbook_employee_entry,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Note Deleted Successfully", { autoClose: 3000 });
        fetchStoreTeamMember(false, selectedTeamMemberId);
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();
      // handlePostError(error);
    }
  };

  // POST /api/user_info/clone_or_reactivate_store_team_member
  // Args:
  //     stm_id  (int):  ID of STM to be "cloned"
  //     store_id (int):  STM will be "cloned" to this store
  //     permission_type (str): The permission type that the new STM will have
  //     permission_type_overrides (array): List of permission override keys
  const clone_or_reactivate_store_team_member = async (
    stm_id,
    store_id,
    permission_type,
    permission_type_overrides
  ) => {
    // Prepare data to send
    const requestData = {
      stm_id: stm_id,
      store_id: store_id,
      permission_type: permission_type,
      permission_type_overrides: permission_type_overrides,
      company_id: props.homeCompany,
    };

    try {
      toast.loading("Adding Access...", { autoClose: false });

      const res = await postRightworkAPI(
        API_clone_or_reactivate_store_team_member,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Access Added!", { autoClose: 3000 });
        if (selectedTeamMemberId) {
          fetchStoreTeamMember(false, selectedTeamMemberId);
        }
        fetch_data(
          {
            users: API_get_list_users,
            archivedUsers: API_get_archived_store_team_members,
          },
          api_params
        );
        return true;
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
    return false;
  };

  // POST /api/user_info/post_store_team_member_only_permission_type_and_store_id
  //   Args:
  //       stm_id  (int):  ID of STM to be updated
  //       store_id (int):  New store_id for the STM
  //       permission_type (str): New permission type for the STM
  //       permission_type_overrides (array): List of permission override keys
  const post_store_team_member_only_permission_type_and_store_id = async (
    stm_id,
    store_id,
    permission_type,
    permission_type_overrides
  ) => {
    // Prepare data to send
    const requestData = {
      stm_id: stm_id,
      store_id: store_id,
      permission_type: permission_type,
      permission_type_overrides: permission_type_overrides,
      company_id: props.homeCompany,
    };

    try {
      toast.loading("Updating Access...", { autoClose: false });

      const res = await postRightworkAPI(
        API_post_store_team_member_only_permission_type_and_store_id,
        requestData
      );

      if (res.status === 200) {
        toast.dismiss();
        toast.success("Access Updated!", { autoClose: 3000 });
        if (selectedTeamMemberId) {
          fetchStoreTeamMember(false, selectedTeamMemberId);
        }
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      toast.dismiss();

      if (error.response?.data?.system?.message) {
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
        // console.log("ERROR MESSAGE", error.response?.data?.system);
      } else {
        toast.error("Request Failed", { autoClose: 3000 });
      }

      console.error("Error:", error); // Handle error as needed
    }
  };

  const bulk_update_store_team_member_permissions = async (
    updates,
    permission_type,
    permission_type_overrides
  ) => {
    const toastId = toast.loading("Updating All Stores...", { autoClose: false });

    try {
      const results = await Promise.allSettled(
        updates.map(({ stm_id, store_id }) =>
          postRightworkAPI(
            API_post_store_team_member_only_permission_type_and_store_id,
            {
              stm_id,
              store_id,
              permission_type,
              permission_type_overrides,
              company_id: props.homeCompany,
            }
          )
        )
      );

      toast.dismiss(toastId);

      const successCount = results.filter((r) => r.status === "fulfilled").length;
      const failCount = results.filter((r) => r.status === "rejected").length;

      if (failCount === 0) {
        toast.success(`Updated ${successCount} store${successCount !== 1 ? "s" : ""}!`, { autoClose: 3000 });
      } else {
        toast.error(`Updated ${successCount}, failed ${failCount}`, { autoClose: 5000 });
      }

      if (selectedTeamMemberId) {
        fetchStoreTeamMember(false, selectedTeamMemberId);
      }
      fetch_data(
        {
          users: API_get_list_users,
        },
        api_params
      );
    } catch (error) {
      toast.dismiss(toastId);
      toast.error("Request Failed", { autoClose: 3000 });
      console.error("Error:", error);
    }
  };

  const create_availability_request = async (data) => {
    /*
    store_id = request.data.get('store_id')
    dow = request.data.get('dow')
    available_from = request.data.get('available_from')
    available_to = request.data.get('available_to')
    note = request.data.get('note')
    user_id = request.user.id
    */

    // Prepare data to send
    let requestData = data;
    requestData["store_id"] = props.homeStore;

    try {
      toast.loading("Creating Availability...", { autoClose: false });
      const res = await postRightworkAPI(
        API_create_availability_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Availability Created Successfully!", {
          autoClose: 3000,
        });

        fetchStoreTeamMember(false, selectedTeamMemberId);
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      // Handle network error
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  const manager_rescind_availability_request = async (
    default_availability_request_id
  ) => {
    const requestData = {
      store_id: props.homeStore,
      default_availability_request_id: default_availability_request_id,
    };

    try {
      toast.loading("Removing Availability...", { autoClose: false });
      const res = await postRightworkAPI(
        API_manager_rescind_availability_request,
        requestData
      );

      if (res && res.status === 200) {
        toast.dismiss();
        toast.success("Availability Removed Successfully!", {
          autoClose: 3000,
        });

        fetchStoreTeamMember(false, selectedTeamMemberId);
        fetch_data(
          {
            users: API_get_list_users,
          },
          api_params
        );
      }
    } catch (error) {
      if (error.response?.data?.system?.message) {
        toast.dismiss();
        toast.error(error.response?.data?.system?.message, { autoClose: 3000 });
      } else {
        toast.dismiss();
        toast.error("Request Failed");
      }
    }
  };

  React.useEffect(() => {
    fetch_data(default_api_calls, api_params, true);
    setShowUserProfile(false);
  }, [props.homeStore]);

  // Refresh employee data when Operations Assistant confirms a team management action
  const opsRefreshMountedRef = React.useRef(false);
  React.useEffect(() => {
    if (!opsRefreshMountedRef.current) {
      opsRefreshMountedRef.current = true;
      return;
    }
    if (!props.opsRefreshSignal) return;
    const { types } = props.opsRefreshSignal;
    if (types?.includes("employees")) {
      fetch_data(
        {
          users: API_get_list_users,
          archivedUsers: API_get_archived_store_team_members,
          posStoreTeamMembers: API_list_pos_store_team_members,
        },
        api_params,
        false
      );
      // Also refresh the individual employee profile if one is open
      if (selectedTeamMemberId) {
        fetchStoreTeamMember(false, selectedTeamMemberId);
      }
    }
    // Time-off and availability changes don't affect the user list,
    // but the profile drawer shows both — and fetchStoreTeamMember
    // pulls API_get_list_time_off_requests_for_stm + the
    // availability slice alongside the rest of the profile.
    if (
      (types?.includes("time_off") || types?.includes("availability")) &&
      selectedTeamMemberId
    ) {
      fetchStoreTeamMember(false, selectedTeamMemberId);
    }
  }, [props.opsRefreshSignal]);

  const userData = data.users?.redux?.payload?.employees;
  const archivedUserData = data.archivedUsers?.redux?.payload?.employees;

  const storeList = data.storeList?.redux?.payload?.stores;

  const isCompanyAdmin = props.storeOptions?.some(
    (m) =>
      m.permission_type === "company_admin" ||
      m.permission_type === "rightwork_internal"
  );

  const posStoreTeamMembers = data?.posStoreTeamMembers?.redux?.payload?.pos_store_team_members
  const storeTeamMemberLookup = data?.posStoreTeamMembers?.redux?.payload?.store_team_members

  // State for user profile

  const [showUserProfile, setShowUserProfile] = React.useState(false);

  // A profile opened from the schedule carries a "Back to schedule" action.
  // Forget that origin whenever the profile view closes, however it closes
  // (back button, store switch, delete), so the next profile from the list
  // gets the normal back button.
  const wasProfileOpenRef = React.useRef(false);
  React.useEffect(() => {
    if (wasProfileOpenRef.current && !showUserProfile) {
      latestMemberFetchRef.current += 1;
      props.onProfileClosed?.();
    }
    wasProfileOpenRef.current = showUserProfile;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showUserProfile]);

  // Deep link from the schedule's person menu: open this member's profile the
  // same way a table row click does, then clear the target.
  React.useEffect(() => {
    const id = props.pendingEmployeeProfileId;
    if (!id) return;
    props.clearPendingEmployeeProfile?.();
    setSelectedTeamMemberId(id);
    // Don't flip the page-level spinner: the profile shows its own loading
    // state until the member data lands.
    fetchStoreTeamMember(false, id, true);
    setShowUserProfile(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pendingEmployeeProfileId]);

  const handleEmployeeTabChange = (tab) => {
    setActiveEmployeeTab(tab);
  };

  const refreshEmployees = () => {
    fetch_data(
      {
        users: API_get_list_users,
        archivedUsers: API_get_archived_store_team_members,
        posStoreTeamMembers: API_list_pos_store_team_members,
      },
      api_params,
      false
    );
  };

  const homeStoreDetails = storeList?.find(
    (storeItem) => storeItem.id === props.homeStore
  );
  const posProvider = homeStoreDetails?.pos_provider;

  const toastLinkingAvailable =
    Boolean(posProvider) && !props.timeEntriesEnabled;

  const [toastModalState, setToastModalState] = React.useState({
    open: false,
    member: null,
    onToastLinkUpdate: null,
    onRequestRefresh: null,
  });

  const handleOpenToastModal = (member, options = {}) => {
    if (!toastLinkingAvailable || !member) {
      return;
    }
    setToastModalState({
      open: true,
      member,
      onToastLinkUpdate: options.onToastLinkUpdate || null,
      onRequestRefresh:
        options.onRequestRefresh || (() => refreshEmployees()),
    });
  };

  const handleCloseToastModal = () => {
    setToastModalState({
      open: false,
      member: null,
      onToastLinkUpdate: null,
      onRequestRefresh: null,
    });
  };



  return (
    <>
      {showLighbox && (
        <div className="absolute w-screen h-screen z-40">
          <Lightbox
            small={selectedImage}
            medium={selectedImage}
            // large={selectedImage}
            hideDownload={true}
            hideZoom={true}
            onClose={() => setShowLightbox(false)}
          />
        </div>
      )}
      {!isLoading ? (
        <div>
          {!showUserProfile && (
            <div>
              <TopBarDisplayTitle
                title="Team Members"
                storeOptions={props.storeOptions}
                homeStore={props.homeStore}
                storeNames={props.storeNames}
                change_home_store={props.change_home_store}
              />
            </div>
          )}
          <div>
            {/* Tabs - Only show when not viewing user profile */}
            {!showUserProfile && (
              <div className="w-[50%] mt-6 px-6">
                <TabsThree
                  activeTab={activeEmployeeTab}
                  handleTabButtonPress={handleEmployeeTabChange}
                  tab1="Current"
                  tab2="Archived"
                  tab3="Certificates"
                />
              </div>
            )}

            {/* Conditionally Render Based on Active Tab */}
            {activeEmployeeTab === "Current" ? (
              <EmployeesTable
                employees={userData}
                storeOptions={props.storeOptions}
                schedulingEnabled={props.schedulingEnabled}
                change_home_store={props.change_home_store}
                posEmployees={posStoreTeamMembers}
                storeTeamMemberLookup={storeTeamMemberLookup}
                hide_store_team_member={hide_store_team_member}
                store_team_member_set_order={store_team_member_set_order}
                post_store_team_member={post_store_team_member}
                archive_store_team_member={archive_store_team_member}
                roleNames={data.roleNames}
                timeEntriesEnabled={props.timeEntriesEnabled}
                showUserProfile={showUserProfile}
                setShowUserProfile={setShowUserProfile}
                profileBackOverride={props.profileBackOverride}
                selectedTeamMemberLoadFailed={selectedTeamMemberLoadFailed}
                retrySelectedTeamMember={() => {
                  const id = lastRequestedMemberIdRef.current ?? selectedTeamMemberId;
                  if (id) fetchStoreTeamMember(false, id, true);
                }}
                fetchStoreTeamMember={fetchStoreTeamMember}
                refreshEmployees={refreshEmployees}
                homeStore={props.homeStore}
                storeNames={props.storeNames}
                updatePersonInfo={updatePersonInfo}
                post_certificate={post_certificate}
                delete_certificate={delete_certificate}
                selectedTeamMemberData={selectedTeamMemberData}
                selectedTeamMemberAvailabilityData={
                  selectedTeamMemberAvailabilityData
                }
                relatedTeamMembersData={relatedTeamMembersData}
                setSelectedTeamMemberId={setSelectedTeamMemberId}
                post_logbook_employee_entry={post_logbook_employee_entry}
                delete_logbook_employee_entry={delete_logbook_employee_entry}
                get_file_upload={get_file_upload}
                homeCompany={props.homeCompany}
                storeList={storeList}
                clone_or_reactivate_store_team_member={
                  clone_or_reactivate_store_team_member
                }
                post_store_team_member_only_permission_type_and_store_id={
                  post_store_team_member_only_permission_type_and_store_id
                }
                bulk_update_store_team_member_permissions={
                  bulk_update_store_team_member_permissions
                }
                create_availability_request={create_availability_request}
                manager_rescind_availability_request={manager_rescind_availability_request}
                proficiencyStarsCount={props.proficiencyStarsCount}
                proficiencyFromLMSEnabled={props.proficiencyFromLMSEnabled}
                logbookEnabled={props.logbookEnabled}
                checkInsEnabled={props.checkInsEnabled}
                maintenanceEnabled={props.maintenanceEnabled}
                itTicketsEnabled={props.itTicketsEnabled}
                marketingTicketsEnabled={props.marketingTicketsEnabled}
                menuTicketsEnabled={props.menuTicketsEnabled}
                permissionRole={props.permissionRole}
                isCompanyAdmin={isCompanyAdmin}
                import_store_team_members_from_pos={import_store_team_members_from_pos}
                link_pos_store_team_member={link_pos_store_team_member}
                archive_pos_store_team_member={archive_pos_store_team_member}
                wagesInRightworkEnabled={props.wagesInRightworkEnabled}
                onOpenToastModal={handleOpenToastModal}
                posProvider={posProvider}
                selectedTeamMemberTimeOffData={selectedTeamMemberTimeOffData}
                request_time_off_for_employee={request_time_off_for_employee}
                rescind_time_off_request={rescind_time_off_request}
              />
            ) : activeEmployeeTab === "Archived" ? (
              <ArchivedEmployeesTable
                archivedEmployees={archivedUserData}
                roleNames={data.roleNames}
                homeStore={props.homeStore}
                clone_or_reactivate_store_team_member={
                  clone_or_reactivate_store_team_member
                }
                onOpenToastLink={handleOpenToastModal}
                toastLinkingAvailable={toastLinkingAvailable}
                refreshEmployees={refreshEmployees}
                posProvider={posProvider}
              />
            ) : (
              <CertificationsTable
                homeStore={props.homeStore}
                homeCompany={props.homeCompany}
                post_certificate={post_certificate}
                delete_certificate={delete_certificate}
                employees={userData}
                roleNames={data.roleNames}
                refreshDependentData={() =>
                  fetch_data(
                    { users: API_get_list_users, roleNames: API_get_roles },
                    api_params
                  )
                }
                onSaveEmergencyContact={async (stmId, name, phone, relationship) => {
                  await postRightworkAPI(API_update_emergency_contact, {
                    stm_id: stmId,
                    store_id: props.homeStore,
                    emergency_contact_name: name,
                    emergency_contact_phone: phone,
                    emergency_contact_relationship: relationship,
                  });
                  toast.success("Emergency Contact Updated!", { autoClose: 3000 });
                  fetch_data(
                    { users: API_get_list_users },
                    api_params
                  );
                }}
              />
            )}
            {toastLinkingAvailable && (
              <ToastEmployeeLinkModal
                open={toastModalState.open}
                member={toastModalState.member}
                storeId={props.homeStore}
                onClose={handleCloseToastModal}
                onRequestRefresh={toastModalState.onRequestRefresh}
                onToastLinkUpdate={(payload) => {
                  toastModalState.onToastLinkUpdate?.(payload);
                }}
              />
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <LoadSpinner />
        </div>
      )}
    </>
  );
}

export default EmployeesInformationDisplay;
